import React, { useEffect, useState } from "react";
import Socket from "../../Global Functions/socket";
import ChatListAdmin from "./chatListAdmin";
import ChatComponentAdmin from "./chatComponentAdmin";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link } from "react-router-dom";
import SearchBar from "../Main/searchBar";
import ChatMirror from "../../Global Functions/chatMirror";
import { useSelector } from "react-redux";
import "./listChatsAdmin.css";
const ListChatsAdmin = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [chatWith, setChatWith] = useState("users");
  const [selectedPerson, setSelectedPerson] = useState("");

  useEffect(() => {
    const onConnect = () => {
      console.log("Connected to socket:", Socket.id);
    };
    Socket.on("connect", onConnect);
    return () => {
      Socket.off("connect", onConnect);
    };
  }, []);

  return (
      <div className="chatAndSupport-content-first">
        <div className="chatMirror-div">
        <ChatMirror
          emailAddress={admin?.data?.email}
          phone={admin?.data?.contact_number}
        ></ChatMirror>
      </div>
      
        <div className="chatAndSupport-content-second help-support-heading-wrapper">
          <div className="chatListAdmin-left">
            <ChatListAdmin
              setSelectedBookingId={setSelectedBookingId}
              chatWith={chatWith}
              setChatWith={setChatWith}
              setSelectedPerson={setSelectedPerson}
              selectedPerson={selectedPerson}

            />
          </div>
          <div className="chatListAdmin-right">
            <ChatComponentAdmin
              chatWith={chatWith}
              selectedBookingId={selectedBookingId}
              selectedPerson={selectedPerson}
            />
          </div>
        </div>
      </div>
  );
};
export default ListChatsAdmin;
